import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext, LobbyBannerContext, UserContext } from 'commons-ui';
import _get from 'lodash/get';

import { APP_LANGUAGE } from 'commons/models/common';
import { IUpdateKeyResponse } from 'pages/admin/zooKeeper/utils/zk.interface';
import useService from '../../utils/useService';
import { ITournamentBanner, TTournamentBannerConfig } from '../../utils/constants';
import { dehydrateFormData, hydrateEditFormData } from '../../utils/formDataParser';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);

	const history = useHistory();
	const location = useLocation();
	const { lobbyBannerData: lobbyBannerRows } = useContext(LobbyBannerContext);
	const { requestCreateLobbyBanner, handleEditConfigBasedLobbyBanner } = useService();

	const updateBanner = (updatedData: ITournamentBanner, index: number, language: APP_LANGUAGE) => {
		setShowLoader(true);
		const lobbyBannerDataConfig: TTournamentBannerConfig = handleEditConfigBasedLobbyBanner(
			updatedData,
			lobbyBannerRows.data,
			language,
			index
		);
		requestCreateLobbyBanner(app.appName, user, lobbyBannerRows.gameName, lobbyBannerDataConfig).then(
			(res: IUpdateKeyResponse) => {
				if (!res?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the banner', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Banner updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		const { language, index } = submittedData;
		updateBanner(dehydrateFormData(submittedData), index, language);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateEditFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
